import { render, staticRenderFns } from "./sellerRating.vue?vue&type=template&id=13eca4af&scoped=true&lang=html&"
import script from "./sellerRating.vue?vue&type=script&lang=js&"
export * from "./sellerRating.vue?vue&type=script&lang=js&"
import style0 from "./sellerRating.vue?vue&type=style&index=0&id=13eca4af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eca4af",
  null
  
)

export default component.exports